<template>
  <div class="h-full">
    <section class="application-create__header">
      <div class="container-fluid">
        <router-link :to="{
        name: 'ApplicantApplicationsList'
      }" class="button__back">
          <svg class="button__icon icon" viewBox="0 0 24 24" width="24" height="24">
            <use xlink:href="@/assets/v2/img/sprite.svg#chevron__left"></use>
          </svg>{{ $lang.app.BACK }}
        </router-link>
        <h3 class="application-create__title">{{ $lang.app.APPLICATION_CREATE }}</h3>
      </div>
    </section>
    <section class="application-create__steps">
      <div class="container-fluid">
        <div class="application-create__steps__wrapper">
          <router-link :to="{
            name: 'ApplicantApplicationMainCreate'
          }" class="step__item" :class="{'step__active': $route.matched.some(item => item.name === 'ApplicantApplicationMainCreate')}">
            <span class="step__count">1</span>
            <span class="step__title">{{ $lang.app.GENERAL_INFORMATION }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </router-link>
          <button class="step__item" @click="alertFillPreviousSteps">
            <span class="step__count">2</span>
            <span class="step__title">{{ $lang.app.APPLICANT_DATA }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </button>
          <button class="step__item" @click="alertFillPreviousSteps">
            <span class="step__count">3</span>
            <span class="step__title">{{ $lang.app.CUSTOMER_DATA }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </button>
          <button class="step__item" @click="alertFillPreviousSteps">
            <span class="step__count">4</span>
            <span class="step__title">{{ $lang.app.CONSTRUCTOR_DATA }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </button>
          <button class="step__item" @click="alertFillPreviousSteps">
            <span class="step__count">5</span>
            <span class="step__title">{{ $lang.app.DOCUMENTS }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </button>
          <button class="step__item" @click="alertFillPreviousSteps">
            <span class="step__count">6</span>
            <span class="step__title">{{ $lang.app.AGREEMENT }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </button>
          <button class="step__item" @click="alertFillPreviousSteps">
            <span class="step__count">7</span>
            <span class="step__title">{{ $lang.app.APPLICATION }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </button>
        </div>
      </div>
    </section>
    <router-view/>
  </div>
</template>
<script>
import {
  getValueByKey as userTypesGetValue,
} from "../../../helpers/constants/userTypes";
export default {

  methods: {
    userTypesGetValue,
    alertFillPreviousSteps() {
      alert(this.$lang.app.FIRST_FILL_PREVIOUS_STEPS + '!');
    },
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      let profileInfo = vm.$store.getters.getCurrentUser

      if(
          (profileInfo.userInfo?.type === vm.userTypesGetValue('INDIVIDUAL_ENTITY')
              && (!profileInfo.userInfo?.bankDetails
                  || !profileInfo.userInfo?.contactDetail
                  || !profileInfo.userInfo?.person
                  || !profileInfo.userInfo?.person?.personDocument))
          ||
          (profileInfo.userInfo?.type === vm.userTypesGetValue('LEGAL_ENTITY')
              && (!profileInfo.userInfo?.bankDetails
                  || !profileInfo.userInfo?.contactDetail
                  || !profileInfo.userInfo?.organization))
          ||
          (profileInfo.userInfo?.type === vm.userTypesGetValue('INDIVIDUAL_ENTREPRENEUR')
              && (!profileInfo.userInfo?.bankDetails
                  || !profileInfo.userInfo?.contactDetail
                  || !profileInfo.userInfo?.individualEnterprise))
      ) {
        vm.$emitter.emit('open-fill-profile-warning-modal')
        vm.$router.push(from.fullPath)
      }
    })
  }
}
</script>